/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import type RequestError from 'flarum/common/utils/RequestError';

export default function shopRequestErrorHandler(e: RequestError): void {
	if (!e.alert) return;

	if (e.response?.errors?.some((err) => err.code === 'article_service_unreachable')) {
		e.alert.content = app.translator.trans('glowingblue-orell-articles.forum.article.service_unreachable');
	}

	app.alerts.show(e.alert, e.alert.content);
}
